/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramGeoControllerGetTreeMultilanguageQueryResponse } from '../types/TelegramGeoControllerGetTreeMultilanguage.ts';

function getTelegramGeoGetTreeMultilanguageUrl() {
  const res = { method: 'GET', url: `/api/telegram/geo/tree/multilanguage` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/tree/multilanguage}
 */
export async function telegramGeoGetTreeMultilanguage(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramGeoControllerGetTreeMultilanguageQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getTelegramGeoGetTreeMultilanguageUrl().url.toString(), ...requestConfig });
  return res.data;
}
